import React, { useEffect, useState } from 'react'
import { getTodayEvents } from '../Common/apis';
import { toast } from 'react-toastify';
import Loader from '../Components/Loader/Loader';

function Events() {
    const [event, setEvent] = useState(null)
    const [loading, setLoading] = useState(false);


    const fetchEvents = async () => {
        setLoading(true);
        try {
            const response = await getTodayEvents();
            setEvent(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchEvents();
    }, []);

    return (
        <>
        {loading && <Loader />}
            <div className='mt-[80px]'>
                <div className='relative'>
                    <img src="/assets/profile/bg-feeds.svg" className='w-full' alt="" />
                    <div className='absolute md:bottom-[60px] bottom-[10px] left-[50%] translate-x-[-50%]'>
                        <h2 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#FFFFFF] tracking-[3px] text-center">Event</h2>
                        <p className="font-[500] font-manrope text-[16px] text-[#FFFFFF] tracking-[3px] text-center">HOME-Contact</p>
                    </div>
                </div>
            </div>
            <section className='feed-section pt-[60px] lg:pb-[287px] pb-[100px] px-[20px]'>
                <div className="max-w-[654px] mx-auto w-full">
                    <div className="grid grid-cols-1 gap-[30px]">
                        <div className='bg-[#FFFFFF] pt-[21px] pb-[16px] px-[20px] rounded-[20px]' style={{ boxShadow: "0px 4px 29px 0px #00000014" }}>
                            <div className="flex pb-[10px] justify-between items-center">
                                <div className="flex items-center gap-[5px]">
                                    <img src="/assets/home/profile.png" alt="" />
                                    <div>
                                        <h6 className="font-[700] text-[14px] font-manrope text-[#000000] tracking-[-0.3px] pb-[4px]">Camila</h6>
                                        <p className="font-[700] font-manrope text-[12px] text-[#747575] tracking-[-0.3px]">Mexico City, Mexico</p>
                                    </div>
                                </div>
                                <button>
                                    <img src="/assets/home/horizon.svg" alt="" />
                                </button>
                            </div>
                            <div className='relative'>
                                <img src="/assets/home/img3.png" className='w-full pb-[10px]' alt="" />
                                <div className="flex flex-col items-center gap-[24px] absolute bottom-[10px] right-[10px] ">
                                    <button>
                                        <img src="/assets/nav/share.svg" alt="" />
                                    </button>
                                    <button className='gap-[8px] px-[15px] pt-[18px] flex flex-col items-center'>
                                        <img src="/assets/nav/comment.svg" alt="" />
                                        <p className="font-[500] font-manrope text-[14px] text-[#FFFFFF]">273</p>
                                    </button>
                                    {/* <button className='bg-[#FF6000] rounded-full gap-[8px] px-[15px] py-[18px] flex flex-col items-center'>
                                        <img src="/assets/nav/like.svg" alt="" />
                                        <p className="font-[500] font-manrope text-[14px] text-[#FFFFFF]">4.2k</p>
                                    </button> */}
                                </div>
                            </div>
                        </div>
                        <div className='bg-[#FFFFFF] pt-[21px] pb-[16px] px-[20px] rounded-[20px]' style={{ boxShadow: "0px 4px 29px 0px #00000014" }}>
                            <div className="flex pb-[10px] justify-between items-center">
                                <div className="flex items-center gap-[5px]">
                                    <img src="/assets/home/profile.png" alt="" />
                                    <div>
                                        <h6 className="font-[700] text-[14px] font-manrope text-[#000000] tracking-[-0.3px] pb-[4px]">Camila</h6>
                                        <p className="font-[700] font-manrope text-[12px] text-[#747575] tracking-[-0.3px]">Mexico City, Mexico</p>
                                    </div>
                                </div>
                                <button>
                                    <img src="/assets/home/horizon.svg" alt="" />
                                </button>
                            </div>
                            <div className='relative'>
                                <img src="/assets/home/img3.png" className='w-full pb-[10px]' alt="" />
                                <div className="flex flex-col items-center gap-[24px] absolute bottom-[10px] right-[10px] ">
                                    <button>
                                        <img src="/assets/nav/share.svg" alt="" />
                                    </button>
                                    <button className='gap-[8px] px-[15px] pt-[18px] flex flex-col items-center'>
                                        <img src="/assets/nav/comment.svg" alt="" />
                                        <p className="font-[500] font-manrope text-[14px] text-[#FFFFFF]">273</p>
                                    </button>
                                    {/* <button className='bg-[#FF6000] rounded-full gap-[8px] px-[15px] py-[18px] flex flex-col items-center'>
                                        <img src="/assets/nav/like.svg" alt="" />
                                        <p className="font-[500] font-manrope text-[14px] text-[#FFFFFF]">4.2k</p>
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Events;